import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import RegisterContainer from '../containers/register'

const RegisterPage = ({ previousPath, isNew }) => {
  const { t } = useTranslation('login-signup')

  return (
    <>
      <RegisterContainer t={t} previousPath={previousPath} isNew={isNew} />
    </>
  )
}

export async function getServerSideProps(context) {
  return {
    props: {
      previousPath: context.req.headers.referer ?? '/',
      isNew: !('old' in context.query),
      ...(await serverSideTranslations(context.locale, [
        'common',
        'header',
        'footer',
        'pdpa',
        'login-signup',
      ])),
    },
  }
}

export default RegisterPage
